import Loading from '@ecp/common/src/components/progress/Loading';

export default Loading;
